'use strict';
import $ from 'jquery';

export default class Status {
    constructor(el) {
        this.el = $(el);
        this.el.find('.module-status-block').each((i, block) => {
            $(block).on('click', '.next, .prev', (e) => {
                e.preventDefault();
                const link = $(e.currentTarget);
                if (!link.data('start'))
                    return;
                const start = link.data('start');
                $(block).find('.spinner').show();
                $.ajax({
                    url: openSystemsJs.ajaxUrl,
                    method: 'POST',
                    data: {
                        action: 'display_status_table',
                        start: start,
                        data: $(block).data('data')
                    },
                    success: (html) => {
                        $(block).html(html);
                        $(block).find('.spinner').hide();
                    }
                });
            });
        });
    }
}